// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3cKwE","content":"RecentSearches_content__2HhEl"};